import React, { useState, useEffect } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'react-multi-carousel/lib/styles.css';
import DashboardLayout from '../../components/DashboardLayout/DashboardLayout';
import DesktopInstallPopup from './desktopInstallPopup';
import DashboardMorePopup from './dashboardSetting/DashboardMorePopup';
import DashboardSettingIndividula from './dashboardSetting/DashboardSettingIndividula';
import DonorProfile from '../../components/navbar/donorModals/DonorProfile';
import MobileMorePopup from './dashboardSetting/MobileMorePopup';
import { formatDisplayDate } from '../../utils/formatDisplayDate';
import API from '../../utils/API';
import LoadingSpinner from '../../components/loadingSpinner/loadingSpinner';
import { BsSearch } from "react-icons/bs";
import { IoMdSettings } from "react-icons/io";
import { Modal, Form, Button } from 'react-bootstrap';
import { MdLocationOn } from "react-icons/md";
import MobileTopBar from '../../components/common/MobileTopBar';
import QuickActionCard from '../../components/common/QuickActionCard/QuickActionCard';
import { FaHome, FaTh, FaUser } from 'react-icons/fa';
import { EnumCategory } from '../searchPage/searchPageTypes';
import emaill from '../../images/email.webp';
import emailCheck from '../../images/email-check.png';
import './DasgboardIndividual.css'
import Carousel from 'react-multi-carousel';
import { settingTrue } from '../../redux/actions';

interface DashboardStats {
  totalGiven: number;
  charitiesSupported: number;
  totalDonated: number;
}

interface LatestDonation {
  id: string;
  organizationName: string;
  campaignName?: string;
  amount: number;
  date: string;
  status: string;
  type: string;
  paymentMethod?: string;
}

interface RecurringDonation {
  id: string;
  organizationName: string;
  amount: number;
  interval: string;
  status: string;
  totalPaid: number;
  date: string
}

interface QuickActionCard {
  icon: string;
  label: string;
  onClick?: () => void;
}

const DasgboardIndividual: React.FC = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [daskboardMorePopup, setDaskboardMorePopup] = useState(false);
  const [mobileMorePopup, setMobileMorePopup] = useState(false);
  const [mobileSettingTab, setMobileSettingTab] = useState(0);
  const [dashboardSetting, setDashboardSetting] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [dashboardStats, setDashboardStats] = useState<DashboardStats | null>(null);
  const [latestDonations, setLatestDonations] = useState<LatestDonation[]>([]);
  const [recurringDonations, setRecurringDonations] = useState<RecurringDonation[]>([]);
  const [loading, setLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showMatchingProgramModal, setShowMatchingProgramModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [matchingProgramForm, setMatchingProgramForm] = useState({
    firstName: '',
    lastName: '',
    company: '',
    position: '',
    companyEmail: '',
    managerName: '',
    teamName: '',
    donationToMatch: ''
  });
  const [locationQuery, setLocationQuery] = useState('');
  const [nonprofits, setNonprofits] = useState<any[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedDonation, setSelectedDonation] = useState<any>(null);
  const [spotlights, setSpotlights] = useState<any[]>([]);

  const redux = useSelector((state: any) => state);
  const userID = redux.signin?._id;
  const userEmail = redux.signin?.email;

  // Quick action cards configuration
  const quickActionCards: QuickActionCard[] = [
    {
      icon: 'mobile-icon/d4.png',
      label: 'Profile',
      onClick: () => history.push('/profile')
    },
    {
      icon: 'mobile-icon/d1.png',
      label: 'Donation History',
      onClick: () => history.push(`/donor/${userID}`)
    },
    {
      icon: 'mobile-icon/d3.png',
      label: 'Recurring Donations',
      onClick: () => history.push('/recurring-donations')
    },
    {
      icon: 'mobile-icon/d2.png',
      label: 'My Fundraisers',
      onClick: () => history.push('/my-fundraisers')
    }
  ];

  // The donor's own fundraisers — drives the "Raise Funds" card, which swaps
  // its intro copy + Start button for progress bars once one exists.
  const [myFundraisers, setMyFundraisers] = useState<any[]>([]);
  useEffect(() => {
    if (!userID) return;
    API.getMyCampaigns(userID)
      .then((res: any) => setMyFundraisers(res.data || []))
      .catch((err: any) => console.log(err));
  }, [userID]);

  const fmtMoney = (n: number) => `$${Math.round(n || 0).toLocaleString('en-US')}`;

  const renderMyFundraisersProgress = (titleSize: number, textSize: number) => (
    <>
      {myFundraisers.map((f: any) => {
        const goal = f.goal || 1;
        const raised = f.progress || 0;
        const pct = raised > 0 ? Math.max(1, Math.min(100, Math.round((raised / goal) * 100))) : 0;
        const path = f.slug
          ? `/fundraiser/${f.slug}`
          : `/fundraiser/${f.orgID?._id || f.orgID}/${f._id}`;
        return (
          <div key={f._id} style={{ marginBottom: 14 }}>
            <div
              onClick={() => history.push(path)}
              style={{ fontSize: titleSize, fontWeight: 600, color: '#111827', cursor: 'pointer', marginBottom: 6 }}
            >
              {f.name}
            </div>
            <div style={{ height: 8, borderRadius: 4, background: '#e5e7eb', overflow: 'hidden' }}>
              <div style={{ width: `${pct}%`, height: '100%', background: '#4ecdc4' }} />
            </div>
            <div style={{ fontSize: textSize, color: '#6b7280', marginTop: 4 }}>
              {`${fmtMoney(raised)} of ${fmtMoney(goal)} raised`}
            </div>
          </div>
        );
      })}
    </>
  );

  const [desktopInstallMessage, setDesktopInstallMessage] = useState(false);
  const reduxInstallPrompt = useSelector(
    (state: any) => state.displayInstallPopup
  );

  // Handle window resize for responsive layout
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const isDesktop = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /Mozilla5.0 (Linux; Android 8.0; Pixel 2 Build|OPD3.170816.012) AppleWebKit|537.36 (KHTML, like Gecko) Chrome|86.0.4240.198 Mobile Safari|537.36/.test(
        userAgent
      );
    };
    const newNavigator: any = window.navigator;
    const isInStandaloneMode = () => newNavigator.standalone;

    if (isDesktop() && !isInStandaloneMode() && !(reduxInstallPrompt % 5)) {
      setDesktopInstallMessage(true);
    }
  }, []);

  useEffect(() => {
    if (userEmail) {
      fetchDashboardData();
    }
  }, [userEmail]);

  useEffect(() => {
    fetchSpotlights();
  }, []);

  const fetchSpotlights = async () => {
    try {
      const response = await API.spotlightReadFunction();
      console.log(response.data, 'response.data');

      setSpotlights(response.data || []);
    } catch (error) {
      console.error('Error fetching spotlights:', error);
    }
  };

  useEffect(() => {
    if (showSearchModal) {
      searchNonprofits();
    }
  }, [searchQuery, locationQuery]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await API.getDashboardStats(userEmail);
      const data = response.data;
      setDashboardStats(data.stats);
      setLatestDonations(data.latestDonations);
      setRecurringDonations(data.recurringDonations);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const searchNonprofits = async () => {
    try {
      setSearchLoading(true);
      const params: { name?: string; location?: string; category?: string } = {};
      if (searchQuery.trim()) params.name = searchQuery.trim();
      if (locationQuery.trim()) params.location = locationQuery.trim();

      const response = await API.searchNonprofits(params);
      if (response.data.success) {
        setNonprofits(response.data.data);
      }
    } catch (error) {
      console.error('Error searching nonprofits:', error);
    } finally {
      setSearchLoading(false);
    }
  };

  // const openSearchModal = () => {
  //   setShowSearchModal(true);
  //   setSearchQuery('');
  //   setLocationQuery('');
  //   // Load all nonprofits initially
  //   searchNonprofits();
  // };

  const closeSearchModal = () => {
    setShowSearchModal(false);
    setSearchQuery('');
    setLocationQuery('');
    setNonprofits([]);
  };


  const normalizePaymentMethod = (method?: string) => {
    if (!method) return 'Card';
    const m = method.toLowerCase();
    if (m === 'apple_pay' || m === 'apple') return 'Apple Pay';
    if (m === 'google_pay' || m === 'google') return 'Google Pay';
    if (m === 'venmo') return 'Venmo';
    if (m === 'paypal') return 'PayPal';
    if (m === 'ach') return 'ACH';
    if (m === 'card') return 'Card';
    if (m === 'recurring') return 'Card';
    return method;
  };

  const formatDate = (dateString: string) => formatDisplayDate(dateString);

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const matchingProgram = async (e : any) => {
    e.preventDefault();
    setIsLoading(true)
 
      try {
        await API.matchingProgram(
          matchingProgramForm.firstName,
          matchingProgramForm.lastName,
          matchingProgramForm.company,
          matchingProgramForm.position,
          matchingProgramForm.companyEmail,
          matchingProgramForm.managerName,
          matchingProgramForm.teamName,
          matchingProgramForm.donationToMatch
        )
         setShowMatchingProgramModal(false);
                // Reset form
                setMatchingProgramForm({
                  firstName: '',
                  lastName: '',
                  company: '',
                  position: '',
                  companyEmail: '',
                  managerName: '',
                  teamName: '',
                  donationToMatch: ''
                });
        setShowSuccessModal(true)
      } catch (error) {

      }finally{
setIsLoading(false)
      }
  }

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 6500, min: 3000 },
      items: 4,
      partialVisibilityGutter: 10
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      partialVisibilityGutter: 10
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 15
    }
  };

  return (
    <>
      <BrowserView style={{ height: '100%' }}>
        <DashboardLayout>
          {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '85  vh' }}>
            <LoadingSpinner />
          </div> :
            <div >
              {/* Main Grid Layout - Responsive */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: windowWidth < 768 ? '1fr' : '1fr 1.5fr',
                gap: windowWidth < 768 ? '16px' : '20px',
                marginBottom: '20px',
                // alignItems: 'start',
              }}>
                {/* Your Impact Journey */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: windowWidth < 768 ? '16px' : '24px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  <h3 style={{
                    margin: '0 0 20px 0',
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#333'
                  }}>
                    Your Impact Journey
                  </h3>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#e3f2fd',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '18px'
                        }}>
                          <img src='/icons/42.png' alt={'share'} style={{ width: "50px", padding: '5px' }} loading="lazy" />
                        </div>
                        <span style={{ fontSize: '14px', color: '#666', fontWeight: 700, }}>This year, you've given</span>
                      </div>
                      <span style={{ fontSize: '16px', fontWeight: 600, color: '#5864FF ' }}>
                        {formatCurrency(dashboardStats?.totalGiven || 0)}
                      </span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#ffebee',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '18px'
                        }}>
                          <img src='/icons/35.png' alt={'share'} style={{ width: "50px", padding: '5px' }} loading="lazy" />
                        </div>
                        <span style={{ fontSize: '14px', color: '#666', fontWeight: 700, }}>You have supported</span>
                      </div>
                      <span style={{ fontSize: '16px', fontWeight: 600, color: '#FF5D53' }}>
                        {dashboardStats?.charitiesSupported || 0} Charities
                      </span>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#e8f5e8',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '18px'
                        }}>
                          <img src='/icons/36.png' alt={'share'} style={{ width: "50px", padding: '5px' }} loading="lazy" />
                        </div>
                        <span style={{ fontSize: '14px', color: '#666', fontWeight: 700, }}>You have donated</span>
                      </div>
                      <span style={{ fontSize: '16px', fontWeight: 600, color: '#4AD991' }}>
                        {formatCurrency(dashboardStats?.totalDonated || 0)} total
                      </span>
                    </div>
                  </div>
                </div>

                {/* Your Giving Hub */}
                <div className="u-g-h" style={{
                  backgroundColor: '#A4A1FB',
                  borderRadius: '12px',
                  padding: windowWidth < 768 ? '16px' : '24px',
                  border: '2px solid #9390E8',
                  color: 'white',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: "column",
                  justifyContent: "space-around",
                  backgroundImage: `url("../../images/d-bg.png")`,
                  ...windowWidth < 768 && { textAlign: 'center' }
                }}>
                  <div className="">
                    <h3 style={{
                      margin: '0 0 8px 0',
                      fontSize: '18px',
                      fontWeight: 800
                    }}>
                      Your Giving Hub: Discover charities,
                    </h3>
                    <p style={{
                      margin: '0 0 20px 0',
                      fontSize: '18px',
                      fontWeight: 700
                    }}>
                      donate, make an impact
                    </p>
                  </div>

                  <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                    <button
                      onClick={() => history.push('/search', { searchCategory: EnumCategory.NonProfits })}
                      style={{
                        backgroundColor: 'white',
                        color: '#333',
                        border: 'none',
                        borderRadius: '25px',
                        padding: '10px 20px',
                        fontSize: '14px',
                        fontWeight: 700,
                        cursor: 'pointer'
                      }}
                    >
                      Search charities
                    </button>
                    <button
                      onClick={() => history.push('/search', { searchCategory: EnumCategory.Campaigns })}
                      style={{
                        backgroundColor: '#fff',
                        color: '#8a86ff',
                        border: '1px solid #fff',
                        borderRadius: '25px',
                        padding: '10px 20px',
                        fontSize: '14px',
                        fontWeight: 700,
                        cursor: 'pointer',
                      }}
                    >
                      Explore fundraisers in need
                    </button>
                  </div>
                </div>
              </div>

              {/* Second Row - Responsive */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: windowWidth < 768 ? '1fr' : '1fr 1.5fr',
                gap: windowWidth < 768 ? '16px' : '20px',
                alignItems: 'start',
              }}>
                <div
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: 12,
                    // A bit more breathing room on both sides — everything in
                    // this card (title, Transactions/See all row, and each
                    // donation row) gets its horizontal inset from this one
                    // padding value, so bumping it moves both edges in.
                    padding: windowWidth < 768 ? '20px 24px' : '16px 20px',
                    boxShadow: '0 2px 8px rgba(16,24,40,0.06)',
                    // height: '55rem',
                  }}
                >
                  {/* Big heading */}
                  <h3
                    style={{
                      margin: 0,
                      fontSize: windowWidth < 768 ? 20 : 18,
                      lineHeight: '32px',
                      fontWeight: 600,
                      color: 'rgb(51, 51, 51)',
                      letterSpacing: '-0.02em',
                    }}
                  >
                    Your Latest Donations
                  </h3>

                  {/* Transactions / See all */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      // alignItems: 'center',
                      marginTop: 16,
                      marginBottom: 8,
                    }}
                  >
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>
                      Transactions
                    </div>

                    <button
                      onClick={() => history.push(`/donor/${userID}`)}
                      style={{
                        appearance: 'none',
                        border: 'none',
                        background: 'transparent',
                        fontSize: 13,
                        fontWeight: 500,
                        color: '#4F46E5',
                        cursor: 'pointer',
                      }}
                    >
                      See all
                    </button>
                  </div>

                  {/* List */}
                  <div style={{ marginTop: 8 }}>
                    {latestDonations.slice(0, 5).map((d, i) => {
                      // helpers
                      const statusStyles = (() => {
                        const base = {
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 6,
                          padding: '2px 10px',
                          borderRadius: 999,
                          fontSize: 11,
                          fontWeight: 600,
                          lineHeight: '18px',
                          border: '1px solid',
                        };
                        if (d?.status?.toLowerCase() === 'completed') {
                          return {
                            ...base,
                            color: '#059669',
                            background: '#ECFDF5',
                            borderColor: '#A7F3D0',
                          };
                        }
                        if (d?.status?.toLowerCase() === 'trailing') {
                          return {
                            ...base,
                            color: '#059669',
                            background: '#ECFDF5',
                            borderColor: '#A7F3D0',
                          };
                        }
                        if (d?.status?.toLowerCase() === 'active') {
                          return {
                            ...base,
                            // color: '#065F46',
                            // background: '#D1FAE5',
                            // borderColor: '#6EE7B7',
                            color: '#059669',
                            background: '#ECFDF5',
                            borderColor: '#A7F3D0',

                          };
                        }
                        if (d?.status?.toLowerCase() === 'created') {
                          return {
                            ...base,
                            color: '#059669',
                            background: '#ECFDF5',
                            borderColor: '#A7F3D0',

                          };
                        }
                        if (d?.status?.toLowerCase() === 'succeeded') {
                          return {
                            ...base,
                            color: '#059669',
                            background: '#ECFDF5',
                            borderColor: '#A7F3D0',
                          };
                        }
                        if (d?.status?.toLowerCase() === 'processing') {
                          return {
                            ...base,
                            color: '#B45309',
                            background: '#FFFBEB',
                            borderColor: '#FDE68A',
                          };
                        }
                        return {
                          ...base,
                          color: '#B91C1C',
                          background: '#FEF2F2',
                          borderColor: '#FECACA',
                        };
                      })();

                      const typeStyles =
                        d?.type?.toLowerCase() === 'recurring'
                          ? {
                            color: '#B45309',
                            background: '#FEF3C7',
                          }
                          : {
                            color: '#3B82F6',
                            background: '#E0E7FF',
                          };

                      return (
                        <div key={d.id}>
                          {i !== 0 && (
                            <div
                              style={{
                                height: 1,
                                background: '#E5E7EB',
                                margin: '14px 0',
                              }}
                            />
                          )}

                          {/* row */}
                          <div
                            style={{
                              display: windowWidth < 768 ? 'flex' : 'grid',
                              flexDirection: windowWidth < 768 ? 'column' : undefined,
                              gridTemplateColumns: windowWidth < 768 ? undefined : '2fr 1fr',
                              // alignItems: windowWidth < 768 ? 'flex-start' : 'center',
                              gap: windowWidth < 768 ? 8 : 16,
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 600,
                                  color: '#111827',
                                  marginBottom: 2,
                                }}
                              >
                                {d.organizationName}
                              </div>
                              <div style={{ fontSize: 13, color: '#050505ff' }}>
                                {d?.campaignName}
                              </div>
                              <div style={{ fontSize: 13, color: '#050505ff' }}>
                                Payment Method: {normalizePaymentMethod(d?.paymentMethod || d?.type)}
                              </div>

                              <div style={{ marginTop: 6, display: 'flex', gap: 12 }}>
                                Status:<span style={statusStyles}>
                                  <span
                                    style={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: '50%',
                                      background:
                                        d?.status?.toLowerCase() === 'completed'
                                          ? '#059669'
                                          : d?.status?.toLowerCase() === 'succeeded'
                                            ? '#059669'
                                            : d?.status?.toLowerCase() === 'active'
                                              ? '#059669'
                                              : d?.status?.toLowerCase() === 'created'
                                                ? '#078642ff'
                                                : d?.status?.toLowerCase() === 'processing'
                                                  ? '#B45309'
                                                  : '#B91C1C',
                                    }}
                                  />
                                  {d?.status?.toLowerCase() === 'completed' || d?.status?.toLowerCase() === 'succeeded' || d?.status?.toLowerCase() === 'active' || d?.status?.toLowerCase() === 'created'
                                    ? 'Completed'
                                    : d?.status?.toLowerCase() === 'processing'
                                      ? 'Processing'
                                      : d?.status?.toLowerCase() === 'cancelled'
                                        ? 'Canceled'
                                        : d?.status?.toLowerCase() === 'trailing'
                                          ? 'Trailing'
                                          : d?.status}
                                </span>


                              </div>
                              <div className="">
                                <span style={{ fontSize: 12, color: '#050505ff', alignSelf: 'center' }}>
                                  {formatDate(d.date)}
                                </span>
                              </div>
                            </div>

                            {/* right: amount */}
                            <div style={{ textAlign: 'right' , display: 'flex' , gap:'10px' , alignItems :'flex-start', justifyContent: 'flex-end'}}>
                                  <span
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 8px',
                                  borderRadius: 25,
                                  fontSize: 10,
                                  fontWeight: 600,
                                  whiteSpace:'nowrap',
                                  ...typeStyles,
                                }}
                              >
                                {d?.type?.toLowerCase() === 'recurring' ? 'Recurring' : 'One time'}
                              </span>
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: 700,
                                  color: '#5271FF',
                                }}
                              >
                                {formatCurrency(d.amount)}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>


                {/* Raise Funds For Your Favorite Cause */}
                <div
                  style={{
                    display: windowWidth < 768 ? 'flex' : 'grid',
                    flexDirection: windowWidth < 768 ? 'column' : undefined,
                    gridTemplateColumns: windowWidth < 768 ? undefined : '1fr 1fr',
                    gap: windowWidth < 768 ? 16 : 16,
                  }}
                >
                  <div className="">
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: windowWidth < 768 ? '16px' : '15px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      position: 'relative',
                      border: '1px solid #f1f0f1'
                    }}>
                      <h4 style={{
                        margin: '0 0 12px 0',
                        fontSize: '15px',
                        fontWeight: 600,
                        color: '#333'
                      }}>
                        Raise Funds For Your Favorite Cause
                      </h4>

                      {myFundraisers.length > 0 ? (
                        renderMyFundraisersProgress(13, 11)
                      ) : (
                        <p style={{
                          fontSize: '12px',
                          color: '#323232',
                          lineHeight: '1.4',
                          margin: '0 0 20px 0',
                          fontWeight: 600
                        }}>
                          Create a fundraiser for the charity you care about most. Share your campaign with friends, family, and your community, and watch the support grow!
                        </p>
                      )}
                      <div style={{ textAlign: 'right' }}>
                        <button onClick={() => history.push('/my-fundraisers')} style={{
                          backgroundColor: '#b1f4d1',
                          color: '#03827e',
                          border: 'none',
                          borderRadius: '25px',
                          padding: '5px 10px',
                          fontSize: '10px',
                          fontWeight: 700,
                          cursor: 'pointer',
                        }}>
                          {myFundraisers.length > 0 ? 'My Fundraisers' : 'Start Fundraising'}
                        </button>
                      </div>
                    </div>
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: windowWidth < 768 ? '16px' : '15px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      display: 'flex',
                      flexDirection: 'column',
                      marginTop: "1rem"
                    }}>
                      <h4 style={{
                        margin: '0 0 12px 0',
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#333'
                      }}>
                        Match Your Donations
                      </h4>

                      <p style={{
                        fontSize: '13px',
                        color: '#323232',
                        lineHeight: '1.4',
                        margin: '0 0 16px 0',
                        fontWeight: 600

                      }}>
                        Create a strong sense of community within your company, uniting colleagues to make a positive impact.
                        {" "}<a href='https://www.neddieblog.com/purpose-match'>Learn More</a>
                      </p>

                      <div className="" style={{textAlign:'right'}}>
                          <button
                            onClick={() => setShowMatchingProgramModal(true)}
                            style={{
                              backgroundColor: '#e7efff',
                              color: '#77a4ff',
                              border: 'none',
                              borderRadius: '25px',
                              padding: '5px 10px',
                              fontSize: '10px',
                              fontWeight: 500,
                              cursor: 'pointer',
                            }}>
                            Submit Request
                          </button>
                        </div>
                    </div>

                    {/* Match your donations */}
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      padding: '24px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      marginTop: '20px'
                    }}>
                      <div
                        style={{
                          margin: '0 0 20px 0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <h4 style={{
                          margin: '0',
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#333'
                        }}>
                          Recurring Donations
                        </h4>
                        <Link to={'/recurring-donations'} style={{color:'rgb(79, 70, 229)'}}>See All</Link>
                      </div>
                      {recurringDonations.length > 0 ? (

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                          {recurringDonations.map((recurring) => (
                            <div key={recurring.id} style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '10px',
                              backgroundColor: '#f8f9fa',
                              borderRadius: '8px',
                              gap: '10px'
                            }}>
                              <div>
                                <div style={{ fontSize: '12px', fontWeight: 500, color: '#333', marginBottom: '4px' }}>
                                  {recurring.organizationName}
                                </div>
                                <div style={{ fontSize: '10px', color: '#666' }}>
                                  {`${recurring.interval}ly donation ${formatDisplayDate(recurring.date)}`}
                                </div>
                              </div>
                              <div style={{ fontSize: '12px', fontWeight: 600, color: '#4AD991' }}>
                                {formatCurrency(recurring.amount)}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : <div>You don’t have any recurring donations to show</div>}

                    </div>
                  </div>
                  {/* Causes of the Month Section */}
                  {spotlights.length > 0 && (
                    <div
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "12px",
                        padding: windowWidth < 768 ? "16px" : "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                      }}
                    >
                      <h3
                        style={{
                          margin: "0 0 16px 0",
                          fontSize: 18,
                          fontWeight: 600,
                          color: "rgb(51, 51, 51)",
                          textAlign: "left",
                        }}
                      >
                        Causes of the Month
                      </h3>
                      <div style={{height: windowWidth < 768 ? "auto" : "66rem", overflowY: "scroll"}}>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
                          {spotlights.slice(0, 4).map((spotlight, index) => {
                            const donateHref = spotlight.donateNow || spotlight.npProfilePage || "#";
                            const bannerTitle = spotlight.bannerTitle || spotlight.category || spotlight.cause || spotlight.title || "";
                            return (
                              <div key={spotlight.id || index}
                                style={{ position: "relative", backgroundColor: "#fff", border: "1px solid #e5e7eb", borderRadius: 18, overflow: "hidden" }}>
                                {bannerTitle ? (
                                  <div
                                    style={{
                                      position: "relative",
                                      top: 0,
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      background: "#8fa2ff",
                                      color: "#ffffff",
                                      padding: "10px 20px",
                                      fontSize: 16,
                                      fontWeight: 800,
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      zIndex: 3,
                                      textAlign: "center",
                                      whiteSpace: "nowrap",
                                      width: "100%",
                                      letterSpacing: 0.2,
                                    }}
                                  >
                                    {bannerTitle}
                                  </div>
                                ) : null}

                                {/* Image */}
                                <div
                                  style={{
                                    height: 225,
                                    backgroundImage: `url(${spotlight.imgURL || ""})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                  }}
                                />

                                {/* Card body */}
                                <div style={{ padding: 16 }}>
                                  {/* Org row with small logo + bold name */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 10,
                                      marginBottom: 10,
                                    }}
                                  >
                                    <img
                                      src={
                                        spotlight.logo ||
                                        "https://via.placeholder.com/28x28.png?text=%20"
                                      }
                                      alt=""
                                      style={{
                                        width: 28,
                                        height: 28,
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                    />
                                    <div
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#1f2937",
                                        lineHeight: 1.1,
                                      }}
                                    >
                                      {spotlight.company || spotlight.name || "Organization"}
                                    </div>
                                  </div>

                                  {/* Description (muted, roomy leading like screenshot) */}
                                  <p
                                    style={{
                                      fontSize: 13,
                                      color: "#6b7280",
                                      lineHeight: 1.6,
                                      margin: "0 0 8px 0",
                                    }}
                                  >
                                    {spotlight.description ||
                                      "We develop the capacities of communities to achieve social and economic transformation."}
                                  </p>

                                  {/* Footer: Donate Now right aligned */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                      marginTop: 8,
                                    }}
                                  >
                                    <a
                                      href={donateHref}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: "#5b79ff", // blue-purple like screenshot
                                        textDecoration: "none",
                                      }}
                                      onMouseEnter={(e) =>
                                        (e.currentTarget.style.textDecoration = "underline")
                                      }
                                      onMouseLeave={(e) =>
                                        (e.currentTarget.style.textDecoration = "none")
                                      }
                                    >
                                      Donate Now
                                    </a>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>


            </div>}
        </DashboardLayout>

        {desktopInstallMessage && (
          <DesktopInstallPopup close={() => setDesktopInstallMessage(false)} />
        )}
      </BrowserView>

      <MobileView>
        <MobileTopBar />

        {/* Horizontal Scrollable Action Items */}
        <div style={{
          backgroundColor: '#fff',
          padding: '16px 10px',
          borderBottom: '1px solid #e5e7eb',
          marginBottom: '0'
        }}>
          {/* Header with See all button */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginBottom: '12px'
          }}>
            {/* <div style={{ fontSize: 16, fontWeight: 600, color: '#111827' }}>
              Quick Actions
            </div> */}
            <button
              onClick={() => history.push('/categories')}
              style={{
                appearance: 'none',
                border: 'none',
                background: 'transparent',
                fontSize: 13,
                fontWeight: 500,
                color: 'rgb(91, 121, 255)',
                cursor: 'pointer',
                padding: 0
              }}
            >
              See all
            </button>
          </div>

          <div style={{
            display: 'flex',
            gap: '10px',
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            paddingBottom: '4px',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}>
            {quickActionCards.map((card, index) => (
              <QuickActionCard
                key={index}
                icon={card.icon}
                label={card.label}
                onClick={card.onClick}
              />
            ))}
          </div>
        </div>

        {/* Overview Section */}
        <div style={{
          backgroundColor: '#758eff',
          margin: '0 10px',
          marginTop: '16px',
          borderRadius: '16px',
          padding: '20px',
          color: 'white'
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: 700,
            margin: '0 0 20px 0',
            color: 'white'
          }}>
            Overview
          </h2>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}>
            {/* This year, you've given */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img style={{ width: "100%" }} src='icons/15.png' />
                </div>
                <span style={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: 'white'
                }}>
                  This year, you've given
                </span>
              </div>
              <span style={{
                fontSize: '13px',
                fontWeight: 700,
                color: 'white'
              }}>
                {formatCurrency(dashboardStats?.totalGiven || 0)}
              </span>
            </div>

            {/* You have supported */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',


                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img style={{ width: "100%" }} src='icons/16.png' />
                </div>
                <span style={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: 'white'
                }}>
                  You have supported
                </span>
              </div>
              <span style={{
                fontSize: '13px',
                fontWeight: 700,
                color: 'white'
              }}>
                {dashboardStats?.charitiesSupported || 0} charities
              </span>
            </div>

            {/* You have donated */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img style={{ width: "100%" }} src='icons/17.png' />
                </div>
                <span style={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: 'white'
                }}>
                  You have donated
                </span>
              </div>
              <span style={{
                fontSize: '13px',
                fontWeight: 700,
                color: 'white'
              }}>
                {formatCurrency(dashboardStats?.totalDonated || 0)} total
              </span>
            </div>
          </div>
        </div>

        {/* Causes of the Month Section */}
        {spotlights.length > 0 && (
          <div
            style={{
              backgroundColor: "#fff",
              padding:"10px",
            }}
          >
            <h3
              style={{
                margin: "20px 0 16px 0",
                fontSize: 18,
                fontWeight: 600,
                color: "rgb(51, 51, 51)",
                textAlign: "left",
              }}
            >
              Causes of the Month

            </h3>
            <div>
              <Carousel
                responsive={responsive}
                removeArrowOnDeviceType={["tablet", "mobile"]}
                partialVisible={true}
                minimumTouchDrag={50}
                transitionDuration={400}
                additionalTransfrom={0}
              >
                {Array.from(spotlights).slice(0, 4).map((spotlight: any, index: any) => {
                  const donateHref = spotlight.donateNow || spotlight.npProfilePage || "#";
                  const bannerTitle = spotlight.bannerTitle || spotlight.category || spotlight.cause || spotlight.title || "";
                  return (
                    <div key={spotlight.id || index}
                      style={{ margin: '0px 5px', height: '100%', backgroundColor: "rgb(229 231 235 / 60%)", border: "1px solid #e5e7eb", borderRadius: 8, display: 'flex' }}>
                      <div style={{ flex: 1 }}>
                        <img src={spotlight.imgURL} alt="" style={{ width: '100%', height: '100%', borderRadius: '8px' }} />
                      </div>

                      <div style={{ padding: 10, flex: 1.2 }}>
                        {bannerTitle ? (
                          <div
                            style={{
                              color: "#000",
                              fontSize: 8,
                              fontWeight: 800,
                              textAlign: "right",
                              width: "100%",
                              margin: '-7px 0px 5px 5px'
                            }}
                          >
                            {bannerTitle}
                          </div>
                        ) : null}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            marginBottom: 2,
                          }}
                        >
                          <img
                            src={
                              spotlight.logo ||
                              "https://via.placeholder.com/28x28.png?text=%20"
                            }
                            alt=""
                            style={{
                              width: 18,
                              height: 18,
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 700,
                              color: "#1f2937",
                              lineHeight: 1.1,
                            }}
                          >
                            {spotlight.company || spotlight.name || "Organization"}
                          </div>
                        </div>
                        <p
                          style={{
                            fontSize: 8,
                            color: "#6b7280",
                            lineHeight: 1.6,
                            margin: "0 0 8px 0",
                          }}
                        >
                          {spotlight.description ||
                            "We develop the capacities of communities to achieve social and economic transformation."}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: 8,
                          }}
                        >
                          <a
                            href={donateHref}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              fontSize: 10,
                              fontWeight: 800,
                              color: "#5b79ff",
                              textDecoration: "none",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration = "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                          >
                            Donate Now
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
              {/* <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
                {spotlights.slice(0, 4).map((spotlight, index) => {
                  const donateHref = spotlight.donateNow || spotlight.npProfilePage || "#";
                  const bannerTitle = spotlight.bannerTitle || spotlight.category || spotlight.cause || spotlight.title || "";
                  return (
                    <div key={spotlight.id || index}
                      style={{ backgroundColor: "rgb(229 231 235 / 60%)", border: "1px solid #e5e7eb", borderRadius: 8, display: 'flex' }}>
                      <div style={{ flex: 1 }}>
                        <img src={spotlight.imgURL} alt="" style={{ width: '100%', height: '100%', borderRadius: '8px' }} />
                      </div>

                      <div style={{ padding: 10, flex: 1 }}>
                        {bannerTitle ? (
                          <div
                            style={{
                              color: "#000",
                              fontSize: 8,
                              fontWeight: 800,
                              textAlign: "right",
                              width: "100%",
                              margin: '-7px 0px 5px 5px'
                            }}
                          >
                            {bannerTitle}
                          </div>
                        ) : null}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            marginBottom: 2,
                          }}
                        >
                          <img
                            src={
                              spotlight.logo ||
                              "https://via.placeholder.com/28x28.png?text=%20"
                            }
                            alt=""
                            style={{
                              width: 18,
                              height: 18,
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 700,
                              color: "#1f2937",
                              lineHeight: 1.1,
                            }}
                          >
                            {spotlight.company || spotlight.name || "Organization"}
                          </div>
                        </div>
                        <p
                          style={{
                            fontSize: 8,
                            color: "#6b7280",
                            lineHeight: 1.6,
                            margin: "0 0 8px 0",
                          }}
                        >
                          {spotlight.description ||
                            "We develop the capacities of communities to achieve social and economic transformation."}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginTop: 8,
                          }}
                        >
                          <a
                            href={donateHref}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              fontSize: 10,
                              fontWeight: 800,
                              color: "#5b79ff",
                              textDecoration: "none",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration = "underline")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                          >
                            Donate Now
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        )}

        <div style={{
          backgroundColor: '#fff',
          margin: '16px 10px',
          borderRadius: '16px',
          padding: '10px 16px',
          border: "1px solid #f4f3f4"
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px'
          }}>
            <h2 style={{
              fontSize: '14px',
              fontWeight: 700,
              margin: '0',
              color: '#111827'
            }}>
              Your Latest Donations
            </h2>
            <button
              onClick={() => history.push(`/donor/${userID}`)}
              style={{
                background: 'none',
                border: 'none',
                color: '#3b82f6',
                fontSize: '12px',
                fontWeight: 500,
                cursor: 'pointer',
                textDecoration: 'none'
              }}
            >
              Past 30 Days ›
            </button>
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
          }}>
            {latestDonations.slice(0, 4).map((donation, index) => {
              const statusStyles = (() => {
                if (donation.status.toLowerCase() === 'completed') {
                  return {
                    backgroundColor: '#fff',
                    color: '#059669',
                    border:"1px solid #059669"
                  };
                }
                if (donation.status.toLowerCase() === 'active' || donation.status.toLowerCase() === 'created') {
                  return {
                    backgroundColor: '#fff',
                    color: '#059669',
                    border:"1px solid #059669"
                  };
                }
                if (donation.status.toLowerCase() === 'succeeded') {
                  return {
                    backgroundColor: '#fff',
                    color: '#059669',
                    border:"1px solid #059669"
                  };
                }
                if (donation.status.toLowerCase() === 'processing' || donation.status.toLowerCase() === 'requires_action') {
                  return {
                    backgroundColor: '#fff',
                    color: '#d97706',
                    border:"1px solid #d97706"
                  };
                }
                return {
                  backgroundColor: '#fff',
                  color: '#dc2626',
                  border:"1px solid #dc2626"
                };
              })();

              const typeStyles = donation.type.toLowerCase() === 'recurring'
                ? { backgroundColor: '#dcfce7', color: '#16a34a' }
                : { backgroundColor: '#fef3c7', color: '#d97706' };

              return (
                <div key={donation.id || index} style={{
                  backgroundColor: '#fff',
                  borderBottom: '1px solid #e5e7eb',
                  overflow: 'hidden',
                  // boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  position: 'relative'
                }}>
                  <div style={{
                    padding: '16px 8px',
                    gap: '60px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start'
                  }}>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        display: 'flex',
                        // alignItems: 'center',
                        gap: '4px',
                        marginBottom: '8px'
                      }}>
                        <span style={{
                          fontSize: '12px',
                          fontWeight: 500,
                          color: '#2e2e2e'
                        }}>
                          {donation.organizationName}
                        </span>
                        <span style={{
                          padding: '2px 6px',
                          borderRadius: '12px',
                          fontSize: '8px',
                          fontWeight: 600,
                          whiteSpace: 'nowrap',
                          height: 'fit-content',
                          ...typeStyles
                        }}>
                          {donation.type.toLowerCase() === 'recurring' ? 'Recurring' : 'One time'}
                        </span>
                      </div>

                      <div style={{
                        fontSize: '12px',
                        color: '#2e2e2e',
                        marginBottom: '6px',
                        // fontWeight: 500
                      }}>
                        {donation.campaignName || 'Help children in need'}
                      </div>

                      <div style={{
                        fontSize: '12px',
                        color: '#2e2e2e',
                        marginBottom: '6px'
                      }}>
                        Payment Method: {normalizePaymentMethod(donation.paymentMethod || donation.type || 'Credit Card')}
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '6px'
                      }}>
                        <span style={{
                          fontSize: '12px',
                          color: '#2e2e2e'
                        }}>
                          Status:
                        </span>
                        <span style={{
                          padding: '0px 6px',
                          borderRadius: '16px',
                          fontSize: '10px',
                          fontWeight: 600,
                          ...statusStyles
                        }}>
                          • {donation.status.toLowerCase() === 'completed' || donation.status.toLowerCase() === 'succeeded' ? 'Completed' :
                            donation.status.toLowerCase() === 'active' || donation.status.toLowerCase() === 'created' ? 'Completed' :
                              donation.status.toLowerCase() === 'trailing' ? 'Trailing' :
                                donation.status.toLowerCase() === 'processing' ? 'Processing' :
                                  donation.status.toLowerCase() === 'cancelled' ? 'Canceled' : 'Failed'}
                        </span>
                      </div>

                      <div style={{
                        fontSize: '13px',
                        color: '#6b7280'
                      }}>
                        {formatDate(donation.date)}
                      </div>
                    </div>

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0px',
                      position: 'relative'
                    }}>
                      <span style={{
                        fontSize: '12px',
                        lineHeight: '12px',
                        fontWeight: 700,
                        color: '#3b82f6'
                      }}>
                        {formatCurrency(donation.amount)}
                      </span>
                      <div style={{ position: 'relative' }}>
                        <button
                          onClick={() => {
                            const dropdown = document.getElementById(`dropdown-${donation.id || index}`);
                            if (dropdown) {
                              dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
                            }
                          }}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#6b7280',
                            fontSize: '16px',
                            cursor: 'pointer',
                            padding: '0px',
                            display: 'flex'
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2">
                            <path d="M6 9l6 6 6-6" />
                          </svg>
                        </button>

                        {/* Dropdown Menu */}
                        <div
                          id={`dropdown-${donation.id || index}`}
                          style={{
                            display: 'none',
                            position: 'absolute',
                            top: '100%',
                            right: '0',
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            zIndex: 1000,
                            minWidth: '180px',
                            marginTop: '4px'
                          }}
                        >
                          <div style={{ padding: '8px 0' }}>
                            <button
                              onClick={() => {
                                setSelectedDonation(donation);
                                setShowEmailModal(true);
                                document.getElementById(`dropdown-${donation.id || index}`)!.style.display = 'none';
                              }}
                              style={{
                                width: '100%',
                                background: 'none',
                                border: 'none',
                                padding: '8px 16px',
                                textAlign: 'left',
                                fontSize: '14px',
                                color: '#374151',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                              }}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4874cd" strokeWidth="2">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                              </svg>
                              Email Receipt
                            </button>

                            {/* {donation.type === 'Recurring' && (
                              <>
                                <button
                                  onClick={() => {
                                    // Handle manage recurring
                                    document.getElementById(`dropdown-${donation.id || index}`)!.style.display = 'none';
                                  }}
                                  style={{
                                    width: '100%',
                                    background: 'none',
                                    border: 'none',
                                    padding: '8px 16px',
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    color: '#374151',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                  }}
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4874cd" strokeWidth="2">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                  </svg>
                                  Manage Recurring
                                </button>

                                <button
                                  style={{
                                    width: '100%',
                                    background: 'none',
                                    border: 'none',
                                    padding: '8px 16px',
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    color: '#dc2626',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                  }}
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                  </svg>
                                  Cancel Subscription
                                </button>
                              </>
                            )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{
            marginTop: '20px',
            textAlign: 'center'
          }}>
            <button
              onClick={() => history.push(`/donor/${userID}`)}
              style={{
                background: 'none',
                border: 'none',
                color: '#3b82f6',
                fontSize: '16px',
                fontWeight: 600,
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
            >
              See all my donations
            </button>
          </div>
        </div>

        {/* Giving Hub & Community Fundraisers Section */}
        <div style={{
          margin: '0 10px 20px 10px'
        }}>
          <div style={{
            display: 'flex',
            gap: '16px',
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            paddingBottom: '4px'
          }}>
            {/* Your Giving Hub Card */}
            <div className="ugh-card" style={{
              width: '100%',
              height: '130px',
              backgroundColor: '#a4a1fb',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              overflow: 'hidden',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              display: 'flex'
            }}>
              {/* Left side - Content */}
              <div className="ugh-card-content" style={{
                width: '160px',
                padding: '20px 16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',

              }}>
                <h3 className="ugh-card-title" style={{
                  fontSize: '13px',
                  fontWeight: 800,
                  margin: '0 0 4px 0',
                  color: 'white',
                  lineHeight: '1.2'
                }}>
                  Your Giving Hub — Discover,
                </h3>
                <p className="ugh-card-subtitle" style={{
                  fontSize: '9px',
                  fontWeight: 700,
                  margin: '0 0 16px 0',
                  color: 'white'
                }}>
                  Donate, Make an Impact
                </p>
                <div style={{ display: 'flex', gap: '6px' }}>
                  <button
                  className="ugh-card-btn"
                  onClick={() => history.push('/search', { searchCategory: EnumCategory.NonProfits })}
                    // onClick={openSearchModal}
                    style={{
                      width: '100%',
                      backgroundColor: 'white',
                      color: '#333',
                      border: 'none',
                      borderRadius: '6px',

                      fontSize: '11px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    Charities
                  </button>
                  <button
                    className="ugh-card-btn"
                    onClick={() => history.push('/search', { searchCategory: EnumCategory.Campaigns })}
                    style={{
                      width: '100%',
                      backgroundColor: 'rgba(255,255,255,0.2)',
                      color: 'white',
                      border: '1px solid rgba(255,255,255,0.3)',
                      borderRadius: '6px',

                      fontSize: '11px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    Fundraisers
                  </button>
                </div>
              </div>

              {/* Right side - Image */}
              <div className="ugh-card-img-wrap">
                <img className="ugh-card-img" style={{ width: "100%" }} src='mobile-icon/width_2400.webp' />
              </div>
            </div>

            {/* Community Fundraisers Card */}
            {/* <div style={{
              width: '320px',
              height: '108px',
              backgroundColor: '#a4a1fb',
              borderRadius: '16px',
              border: '1px solid #e5e7eb',
              overflow: 'hidden',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              display: 'flex'
            }}>
              <div style={{
                width: '160px',
                padding: '20px 16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',

              }}>
                <h3 style={{
                  fontSize: '13px',
                  fontWeight: 800,
                  margin: '0 0 4px 0',
                  color: '#393939',
                  lineHeight: '1.2'
                }}>
                  Community Fundraisers,
                </h3>

                <div style={{ display: 'flex', gap: '6px' }}>
                  <button
                    onClick={() => history.push('/search')}
                    style={{
                      width: '100%',
                      backgroundColor: '#6fe4ff',
                      color: '#393939',
                      border: '1px solid #09d1ff',
                      whiteSpace: "nowrap",
                      borderRadius: '6px',

                      fontSize: '11px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    See all fundraisers
                  </button>
                </div>
              </div>
              <div className="">
                <img alt='icon' style={{ width: "100%" }} src='mobile-icon/did.webp' />
              </div>
            </div> */}
          </div>
        </div>

        {/* Raise Funds Section */}
        <div style={{
          backgroundColor: '#fff',
          margin: '16px 10px',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          position: 'relative',
          border: '1px solid #f1f0f1'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: 700,
            margin: '0 0 12px 0',
            color: '#111827',
            lineHeight: '1.3'
          }}>
            Raise Funds For Your Favorite Cause
          </h3>

          {myFundraisers.length > 0 ? (
            renderMyFundraisersProgress(15, 12)
          ) : (
            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              lineHeight: '1.5',
              margin: '0 0 20px 0',
              fontWeight: 400
            }}>
              Create a fundraiser for the charity you care about. Share your campaign with friends, family, and your community, and watch the support grow!
            </p>
          )}

          <div className="" style={{ display: "flex", justifyContent: 'end' }}>
            <button
              onClick={() => history.push('/my-fundraisers')}
              className="rf-card-btn"
              style={{
                backgroundColor: '#b1f4d1',
                color: '#03827e',
                border: 'none',
                borderRadius: '25px',
                padding: '5px 10px',
                fontSize: '10px',
                fontWeight: 700,
                cursor: 'pointer',

              }}
            >
              {myFundraisers.length > 0 ? 'My Fundraisers' : 'Start a Fundraiser'}
            </button>
          </div>
        </div>

        {/* Match your donations */}
        <div style={{
          backgroundColor: '#fff',
          margin: '16px 10px',
          borderRadius: '16px',
          padding: '20px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          position: 'relative',
          border: '1px solid #f1f0f1'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: 700,
            margin: '0 0 12px 0',
            color: '#111827',
            lineHeight: '1.3'
          }}>
            Match Your Donations
          </h3>

          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: '1.5',
            margin: '0 0 20px 0',
            fontWeight: 400

          }}>
            Create a strong sense of community within your company, uniting colleagues to make a positive impact.
            {" "}<a href='https://www.neddieblog.com/purpose-match' target='_blank' >Learn More</a>
          </p>

          <div className="" style={{ textAlign: 'right' }}>
            <button
              onClick={() => setShowMatchingProgramModal(true)}
              className="rf-card-btn"
              style={{
                backgroundColor: '#e7efff',
                color: '#77a4ff',
                border: 'none',
                borderRadius: '25px',
                padding: '5px 10px',
                fontSize: '10px',
                fontWeight: 500,
                cursor: 'pointer',
              }}>
              Submit Request
            </button>
          </div>
        </div>

        {/* Fixed Footer Navigation */}
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          borderTop: '1px solid #e5e7eb',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
          zIndex: 1000,
          padding: '4px 0 0px 0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            maxWidth: '400px',
            margin: '0 auto'
          }}>
            {/* Home */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              padding: '8px'
            }}>
              <div style={{


                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

              }}>
                <FaHome style={{ fontSize: "22px", color: '#5271ff' }} />
              </div>
              <span style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#5271ff'
              }}>
                Home
              </span>
            </div>

            {/* Give hub */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              padding: '8px'
            }}
            onClick={() => history.push('/categories')}
            >
              <div style={{

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px'
              }}>
                <FaTh style={{ fontSize: "22px", color: '#b6b6b6' }} />

              </div>
              <span style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#6b7280'
              }}>
                GiveHub
              </span>
            </div>

            {/* Profile */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              cursor: 'pointer',
              padding: '8px'
            }}
              onClick={() => history.push('/profile')}
            >
              <div style={{


                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px'
              }}>
                <FaUser style={{ fontSize: "22px", color: '#b6b6b6' }} />
              </div>
              <span style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#6b7280'
              }}>
                Profile
              </span>
            </div>

            {/* Settings */}
            {/* TOOD: Change it to donor Settings modal */}
            <div
              onClick={() => dispatch(settingTrue(true))}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
                padding: '8px'
              }}
            >
              <div id='settings' style={{

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px'
              }}>
                <IoMdSettings style={{ fontSize: "22px", color: '#b6b6b6' }} />
              </div>
              <span style={{
                fontSize: '11px',
                fontWeight: 500,
                color: '#6b7280'
              }}>
                Settings
              </span>
            </div>
          </div>
        </div>

        {/* Add bottom padding to account for fixed footer */}
        <div style={{ height: '80px' }}></div>
      </MobileView>

      <MobileMorePopup daskboardMorePopup={mobileMorePopup} setDaskboardMorePopup={setMobileMorePopup} />
      <DashboardMorePopup daskboardMorePopup={daskboardMorePopup} setDaskboardMorePopup={setDaskboardMorePopup} />
      <DashboardSettingIndividula dashboardSetting={dashboardSetting} setDashboardSetting={setDashboardSetting} mobileSettingTab={mobileSettingTab} setMobileSettingTab={setMobileSettingTab} />
      <DonorProfile
        show={showProfileModal}
        hide={() => setShowProfileModal(false)}
      />

      {/* Search Charities Modal */}
      {showSearchModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: '24px',
            maxWidth: '520px',
            width: '100%',
            maxHeight: '84vh',
            overflow: 'auto',
            boxShadow: '0 20px 50px rgba(0,0,0,.18)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h2 style={{ margin: 0, fontSize: '26px', fontWeight: 700 }}>Choose a Charity</h2>
              <button
                onClick={closeSearchModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '22px',
                  cursor: 'pointer',
                  color: '#9ca3af', padding: 6, borderRadius: 8
                }}
              >
                ×
              </button>
            </div>

            {/* Single Search Input with Icon */}
            <div style={{ margin: '6px 0 14px' }}>
              <div style={{
                position: 'relative',
                display: 'flex', alignItems: 'center',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '10px 12px 10px 13px',
                background: '#fff'
              }}>
                {/* search icon */}
                <BsSearch style={{ color: "#6b7280", marginRight: "1rem", fontSize: "20px" }} />
                <input
                  type="text"
                  placeholder="Search by name, location, or cause…"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{
                    border: 'none', outline: 'none', width: '100%',
                    fontSize: '18px', color: '#111827'
                  }}
                />
              </div>
            </div>

            {/* Nonprofit List */}
            <div style={{ maxHeight: '420px', overflow: 'auto', paddingRight: 2 }}>
              {searchLoading ? (
                <div style={{ textAlign: 'center', padding: '36px' }}>Loading...</div>
              ) : nonprofits.length === 0 ? (
                <div style={{
                  textAlign: 'center', padding: '36px', color: '#6b7280',
                  border: '1px dashed #e5e7eb', borderRadius: '12px'
                }}>
                  No charities found. Try different search terms.
                </div>
              ) : (
                <div style={{
                  border: '1px solid #e5e7eb',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  background: '#fff'
                }}>
                  {nonprofits.map((np, idx) => (
                    <div
                      key={np.id}
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        gap: 8,
                        padding: '14px 16px',
                        borderBottom: idx !== nonprofits.length - 1 ? '1px solid #eef0f4' : 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                      }}
                      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f6f7fb')}
                      onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                    >
                      <div style={{ minWidth: 0 }}>
                        <div style={{
                          fontSize: 16, fontWeight: 700, color: '#111827',
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginBottom: 4
                        }}>
                          {np.name}
                        </div>
                        <div style={{
                          fontSize: 13, color: '#6b7280',
                          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                        }}>

                          <MdLocationOn style={{ color: "##cbcac9" }} />  {np.location}
                        </div>
                      </div>

                      <div style={{
                        justifySelf: 'end',
                        color: '#6b7280',
                        padding: '6px 10px',
                        borderRadius: 9999,
                        fontSize: 12,
                        fontWeight: 600,
                        whiteSpace: 'nowrap'
                      }}>
                        {np.category || 'Health'}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Email Receipt Modal */}
      {showEmailModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: '24px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 20px 50px rgba(0,0,0,.18)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 700 }}>Email Receipt</h3>
              <button
                onClick={() => setShowEmailModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#9ca3af', padding: 6, borderRadius: 8
                }}
              >
                ×
              </button>
            </div>

            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              marginBottom: '20px',
              lineHeight: '1.5'
            }}>
              Enter email address to receive your donation receipt {selectedDonation ? `for ${selectedDonation.organizationName}` : ''}.
            </p>

            <input
              type="email"
              placeholder="Email Address"
              defaultValue={userEmail}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '16px'
              }}
            />

            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => setShowEmailModal(false)}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  backgroundColor: 'transparent',
                  color: '#6b7280',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  // Handle email receipt functionality here
                  console.log('Sending email receipt for:', selectedDonation);
                  setShowEmailModal(false);
                }}
                style={{
                  flex: 1,
                  padding: '10px 16px',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                Send Email
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Matching Program Form Modal */}
      <Modal centered show={showMatchingProgramModal} onHide={() => setShowMatchingProgramModal(false)} className='e-d-r'>
        <span onClick={() => setShowMatchingProgramModal(false)} className='close-cp'>X</span>
        <h3 style={{ color: '#5271ff', marginBottom: '20px' }}>Matching Program Form</h3>
        <Form className='donor-profile-email-form' onSubmit={matchingProgram}>
          <div style={{ display: 'flex', gap: '15px' }}>
            <Form.Group style={{ flex: 1 }} >
              <Form.Control
                type='text'
                placeholder='Name'
                value={matchingProgramForm.firstName}
                onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, firstName: e.target.value })}
                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
              />
            </Form.Group>
            <Form.Group style={{ flex: 1 }}>
              <Form.Control
                type='text'
                placeholder='Last Name'
                value={matchingProgramForm.lastName}
                onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, lastName: e.target.value })}
                style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
              />
            </Form.Group>
          </div>
          <Form.Group style={{ marginBottom: '15px' }}>
            <Form.Control
              type='text'
              placeholder='Company / Organization'
              value={matchingProgramForm.company}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, company: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '15px' }}>
            <Form.Control
              type='text'
              placeholder='Position'
              value={matchingProgramForm.position}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, position: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '15px' }}>
            <Form.Control
              type='email'
              placeholder='Company Email'
              value={matchingProgramForm.companyEmail}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, companyEmail: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '15px' }}>
            <Form.Control
              type='text'
              placeholder='Manager Name'
              value={matchingProgramForm.managerName}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, managerName: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '15px' }}>
            <Form.Control
              type='text'
              placeholder='Team Name'
              value={matchingProgramForm.teamName}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, teamName: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '20px' }}>
            <Form.Control
              type='text'
              placeholder='Donation to Match'
              value={matchingProgramForm.donationToMatch}
              onChange={(e) => setMatchingProgramForm({ ...matchingProgramForm, donationToMatch: e.target.value })}
              style={{ padding: '10px', borderRadius: '6px', border: '1px solid #d1d5db' }}
            />
          </Form.Group>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              type="submit"
              style={{
                borderRadius: '50px',
                padding: '6px 26px',
                backgroundColor: '#5271ff',
                border: '1px solid #5271ff',
                color: 'white',
                fontWeight: 600
              }}
            >
              {isLoading ? "Loading..." : "Save" }
            </Button>
            <Button
              onClick={() => setShowMatchingProgramModal(false)}
              style={{
                borderRadius: '50px',
                padding: '6px 26px',
                backgroundColor: '#5271ff',
                border: '1px solid #5271ff',
                color: 'white',
                fontWeight: 600
              }}
            >
              Close
            </Button>
          </div>
        </Form>
      </Modal>
     <Modal centered show={showSuccessModal} onHide={() => setShowSuccessModal(false)} className='requires-action-popups'>
        <span onClick={() => { setShowSuccessModal(false) }} className='close-cp'>X</span>
        <img src={emaill} alt="" width={'80px'} />
        <p style={{ fontWeight: 700 }}>Email sent successfully! <img src={emailCheck} alt="" width={'18px'} /></p>
      </Modal>
    </>
  );
};

export default DasgboardIndividual;

